import { Theme } from '@indigo-ag/component-module';
import React from 'react';

import { Card, CardProps, createStylesHook } from 'shared';

const useStyles = createStylesHook((theme: Theme) => ({
  size28: {
    fontSize: theme.typography.pxToRem(28),
    fontWeight: 300
  },
  containerActionButtons: {
    display: 'flex',
    textAlign: 'right'
  }
}));

interface PhaseWrapperProps {
  subtitleElement?: JSX.Element;
  title: CardProps['title'];
  actionElement?: JSX.Element;
}

export const PhaseWrapper: React.FunctionComponent<PhaseWrapperProps> = ({
  children,
  title,
  actionElement,
  subtitleElement
}) => {
  /**
   * Styles
   */
  const classes = useStyles();

  return (
    <div style={{ minWidth: 738, padding: 0 }}>
      <Card
        title={title}
        topRightContent={<div className={classes.containerActionButtons}>{!!actionElement && actionElement}</div>}
      >
        {!!subtitleElement && subtitleElement}
      </Card>
      {children}
    </div>
  );
};
